/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 商品コード
     * @type {string}
     * @memberof Item
     */
    itemCode: string;
    /**
     * 発注数（ケース）
     * @type {number}
     * @memberof Item
     */
    orderQuantity: number;
    /**
     * ケースサイズ 重量（グラム）
     * @type {number}
     * @memberof Item
     */
    weight: number;
    /**
     * 1パレット：最大積載ケース数
     * @type {number}
     * @memberof Item
     */
    maxPalletQuantity: number;
}

/**
 * Check if a given object implements the Item interface.
 */
export function instanceOfItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "itemCode" in value;
    isInstance = isInstance && "orderQuantity" in value;
    isInstance = isInstance && "weight" in value;
    isInstance = isInstance && "maxPalletQuantity" in value;

    return isInstance;
}

export function ItemFromJSON(json: any): Item {
    return ItemFromJSONTyped(json, false);
}

export function ItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): Item {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'itemCode': json['item_code'],
        'orderQuantity': json['order_quantity'],
        'weight': json['weight'],
        'maxPalletQuantity': json['max_pallet_quantity'],
    };
}

export function ItemToJSON(value?: Item | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'item_code': value.itemCode,
        'order_quantity': value.orderQuantity,
        'weight': value.weight,
        'max_pallet_quantity': value.maxPalletQuantity,
    };
}

